import { findConfig } from '@repo/money'

export const getCurrencySymbol = (currency: string): string => {
  try {
    const config = findConfig(currency, currency)
    return config.symbol
  } catch (error) {
    return '$'
  }
}
